import { Button, FormLabel, IconButton, Input, InputAdornment, makeStyles, OutlinedInput, TextField } from '@material-ui/core';
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { brtoLf, convHankaku, findDeepPath, formatDate, getLodingStatus, lfToBr, makeUrlSearchParams, randomStr, zp } from '../../commonModule';
import { LoadingSpinner } from '../common/commonParts';
import { endPoint } from "../../albCommonModule";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { teal, amber, lightBlue, grey, red } from '@material-ui/core/colors';
import SnackMsg from '../common/SnackMsg';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

const useStyles = makeStyles({
  cntckEdit: {
    minWidth: 600,
    position: 'relative',
    '& .title': {
      padding: 8,
      textAlign: 'center',
      color: teal[800],
      fontWeight: 'bold',
      backgroundColor: teal[50],
      borderBottom: `1px solid ${teal[300]}`
    },
    '& .msgTitle': {
      fontSize: '0.75rem',
      color: grey[500],
      paddingBottom: 4,
      borderBottom: `1px solid ${teal[300]}`,
      marginBottom: 8
    },
    '& .row': {
      
      // paddingBottom: 4
    },
    '& .userInfo': {
      marginTop: 32,
      marginBottom: 56,
      borderBottom: `1px solid ${teal[300]}`,
      paddingBottom: 8,
      '& span': {
        marginRight: 16
      }
    },
    '& .contactMsg': {
      // margin: '24px 0',
      marginBottom: 56,
      '& .str': {
        lineHeight: '1.5rem'
      },
      '& .input': {
        marginTop: 16
      }
    },
    '& .buttonContainer': {
      textAlign: 'right',
      marginTop: 8,
    },
  },
  msgForm: {
    width: '656px',
    '& .textField': {
      width: '41rem',
      '& .MuiFormLabel-root': {
        '& .MuiInput-underline': {
          '&:before': {
            borderColor: teal[600]
          }
        }
      }
    },
    '& .beforeSendingImg': {
      display: 'flex',
      flexWrap: 'wrap',
      width: 648,
      margin: '0 auto'
    },
    '& .addImgErrMsg': {
      color: 'red',
      margin: 4,
      lineHeight: '1.25rem',
      whiteSpace: "pre-wrap",
    },
    '& .sendedImg': {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      // width: 580,
      // margin: '0 auto'
    }
  },
  imgWithDeleteFunc: {
    width: 'fit-content',
    margin: '8px 8px 0 8px',
    display: 'flex',
    flexDirection: 'column',
    '& .deleteImg': {
      display: 'flex',
      alignItems: 'center',
      width: 'fit-content',
      margin: '0 auto',
      '& .iconButtonStr': {
        fontSize: '1rem'
      }
    }
  },
  vitalForm: {
    display: "flex",
    flexDirection: "column",
    margin: '8px 0'
  }
})

const getCntbkDateTime = (dateObj) => {
  const w_year = String(dateObj.getFullYear());
  const w_month = String(dateObj.getMonth()+1).padStart(2, '0');
  const w_date = String(dateObj.getDate()).padStart(2, '0');
  const w_hour = String(dateObj.getHours()).padStart(2, '0');
  const w_minutes = String(dateObj.getMinutes()).padStart(2, '0');
  return `${w_year}-${w_month}-${w_date} ${w_hour}:${w_minutes}`;
}

const backHistory = (contactsDt, uid, setSnack, allState) => {
  const {hid, bid, stdDate} = allState;
  const send_data = {...contactsDt};
  if(!send_data["UID"+uid]) send_data["UID"+uid] = {};
  send_data["UID"+uid].locked = false;
  const parms = {a: "sendPartOfContact", hid, bid, date: stdDate, partOfContact: JSON.stringify(send_data)};
  axios.post(endPoint(), makeUrlSearchParams(parms)).then(res => {
    if(!res.data.result){
      setSnack({...{msg: '書き込みに失敗しました。', severity: 'warning'}});
    }else{
      window.history.back();
    }
  })
}

const HistoryButton = (props) => {
  const {allState, contactsDt, uid, setSnack} = props;
  const handleClick = () => {
    backHistory(contactsDt, uid, setSnack, allState);
  }
  return(
    <IconButton onClick={handleClick} style={{position: 'fixed', top: 150, left: 80}}>
      <ArrowBackIosIcon />
      <span style={{fontSize: 16}}>戻る</span>
    </IconButton>
  )
}

const ContentTextField = (props) => {
  const {contentText, setContentText, disabled=false, disabledDt, setDisabledDt} = props;
  const handleChange = (e) => {
    setContentText(e.target.value);
    setDisabledDt({...disabledDt, contentText: false});
  }
  return(
    <FormLabel>
      <OutlinedInput
          className='textField'
          multiline
          disabled={disabled}
          value={brtoLf(contentText)}
          onChange={handleChange}
        />
    </FormLabel>
  )
}

const exceptionVitalForm = (text, dtName, kind, vitalDt) => {
  if(kind || kind===0){
    if(dtName === "bloods"){
      const origin = vitalDt[dtName] ?[...vitalDt[dtName]] :["", "", ""];
      origin[kind] = text;
      return origin;
    }else if(dtName === "sleep" && kind !== "sleeptime"){
      const origin = vitalDt[dtName] ?vitalDt.sleep.includes("-") ?vitalDt.sleep.split("-") :null :null;
      if(origin && kind === "bedtime"){
        return `${text}-${origin[1]}`;
      }else if(origin && kind === "wakeuptime"){
        return `${origin[0]}-${text}`;
      }else if(!origin && kind === "bedtime"){
        return `${text}-`;
      }else if(!origin && kind === "wakeuptime"){
        return `-${text}`;
      }
    }
  }
  return text;
}

const VitalFormTextField = (props) => {
  const {dtName, kind="", vitalDt, setVitalDt, val, label, placeholder, adronment="", width, varidate=null, disabledDt, setDisabledDt, errMsg=""} = props;
  const [inputError, setInputError] = useState(false);
  const handleChange = (e) => {
    const text = e.target.value;
    const data = {...vitalDt};
    // if(kind || kind===0){
    //   if(dtName === "bloods"){
    //     const origin = vitalDt[dtName] ?[...vitalDt[dtName]] :["", "", ""];
    //     origin[kind] = text;
    //     data[dtName] = origin;
    //   }else if(dtName === "sleep" && kind !== "sleeptime"){
    //     const origin = vitalDt[dtName] ?vitalDt.sleep.includes("-") ?vitalDt.sleep.split("-") :null :null;
    //     if(origin && kind === "bedtime"){
    //       data[dtName] = `${text}-${origin[1]}`;
    //     }else if(origin && kind === "wakeuptime"){
    //       data[dtName] = `${origin[0]}-${text}`;
    //     }else if(!origin && kind === "bedtime"){
    //       data[dtName] = `${text}-`;
    //     }else if(!origin && kind === "wakeuptime"){
    //       data[dtName] = `-${text}`;
    //     }
    //   }else if(dtName === "sleep" && kind === "sleeptime"){
    //     data[dtName] = text;
    //   }
    // }else{
    //   data[dtName] = text;
    // }
    data[dtName] = exceptionVitalForm(text, dtName, kind, vitalDt);
    setVitalDt({...data});
    if(varidate && !new RegExp(varidate).test(text)){
      setInputError(true);
      setDisabledDt({...disabledDt, [dtName+kind]: true});
    }else{
      setDisabledDt({...disabledDt, [dtName+kind]: false});
      setInputError(false);
    }
  }
  const handleBlur = (e) => {
    const han_text = convHankaku(e.target.value);
    const data = {...vitalDt};
    data[dtName] = exceptionVitalForm(han_text, dtName, kind, vitalDt);
    setVitalDt({...data})
  }

  return(
    <TextField
      error={inputError}
      label={label}
      placeholder={placeholder}
      value={val}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        endAdornment: <InputAdornment position="end">{adronment}</InputAdornment>,
      }}
      helperText={inputError ?errMsg :""}
      style={{margin: "8px 8px 8px 4px", width}}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  )
}

const VitalForm = (props) => {
  const classes = useStyles();
  const {vitalDt, setVitalDt, comEtc, disabledDt, setDisabledDt} = props;
  const vitalRequired = comEtc
    ?comEtc["settingContactBook"]
      ?comEtc["settingContactBook"]["bitalRequired"] ?comEtc["settingContactBook"]["bitalRequired"] :[]
      :[]
    :[];
  if(!vitalRequired[2]) return null;
  const vital_info = comEtc
    ?comEtc["settingContactBook"]
      ?comEtc["settingContactBook"]["vital"] ?comEtc["settingContactBook"]["vital"] :{}
      :{}
    :{};
  const temperature_val = vitalDt.temperature ?vitalDt.temperature :"";
  const maxBloodPressure_val = vitalDt.bloods ?vitalDt.bloods[0] :"";
  const minBloodPressure_val = vitalDt.bloods ?vitalDt.bloods[1] :"";
  const bloodPulse_val = vitalDt.bloods ?vitalDt.bloods[2] :"";
  const excretion_val = vitalDt.excretion ?vitalDt.excretion :"";
  const spo2_val = vitalDt.spo2 ?vitalDt.spo2 :"";
  const sleeptime_val = vitalDt.sleep ?!vitalDt.sleep.includes("-") ?vitalDt.sleep :"" :"";
  const bedtime_val = vitalDt.sleep ?vitalDt.sleep.includes("-") ?vitalDt.sleep.split("-")[0] :"" :"";
  const wakeuptime_val = vitalDt.sleep ?vitalDt.sleep.includes("-") ?vitalDt.sleep.split("-")[1] :"" :"";
  const temperature = {
    dtName: 'temperature', val: temperature_val, label: "体温", placeholder: "例：36.5", adronment: "度", width: '8rem',
    varidate: "(^[1-9１-９][0-9０-９]\\.[0-9０-９]+$)|(^[1-9１-９][0-9０-９]$)", errMsg: "数字または小数点のみ"
  }
  const maxBloodPressure = {
    dtName: "bloods", kind: 0, val: maxBloodPressure_val, label: "最高血圧", placeholder: "例：120", adronment: "mmHg", width: '8rem',
    varidate: "^[1-9１-９][0-9０-９]{0,2}$", errMsg: "数字のみ"
  }
  const minBloodPressure = {
    dtName: "bloods", kind: 1, val: minBloodPressure_val, label: "最低血圧", placeholder: "例：80", adronment: "mmHg", width: '8rem',
    varidate: "^[1-9１-９][0-9０-９]{0,2}$", errMsg: "数字のみ"
  }
  const bloodPulse = {
    dtName: "bloods", kind: 2, val: bloodPulse_val, label: "脈拍", placeholder: "例：90", adronment: "回/分", width: '8rem',
    varidate: "^[1-9１-９][0-9０-９]{0,2}$", errMsg: "数字のみ"

  }
  const excretion = {
    dtName: "excretion", val: excretion_val, label: "排泄", placeholder: "例：大○回、小○回", width: '10rem',

  }
  const spo2 = {
    dtName: "spo2", val: spo2_val, label: "血中酸素濃度", placeholder: "例：96", adronment: "%", width: '8rem',
    varidate: "(^[1-9１-９][0-9０-９]{0,1}\\.[0-9０-９]+$)|(^[1-9１-９][0-9０-９]{0,2}$)", errMsg: "数字または小数点のみ"
  }
  const sleeptime = {
    dtName: "sleep", kind: "sleeptime", val: sleeptime_val, label: "睡眠時間", placeholder: "例：8.5", width: '8rem', adronment: "時間",
    varidate: "(^[1-9１-９][0-9０-９]{0,1}\\.[0-9０-９]+$)|(^[1-9１-９][0-9０-９]{0,2}$)", errMsg: "数字または小数点のみ"
  }
  const bedtime = {
    dtName: "sleep", kind: "bedtime", val: bedtime_val, label: "就寝時間", placeholder: "例：22:00", width: '8rem',
    varidate: "^[1-2１-２]{0,1}[0-9０-９]:[0-5０-５][0-9０-９]$", errMsg: ":で分けた数字のみ"
  }
  const wakeuptime = {
    dtName: "sleep", kind: "wakeuptime", val: wakeuptime_val, label: "起床時間", placeholder: "例：7:00", width: '8rem',
    varidate: "^[1-2１-２]{0,1}[0-9０-９]:[0-5０-５][0-9０-９]$", errMsg: ":で分けた数字のみ"
  }
  const common_parms = {vitalDt, setVitalDt, disabledDt, setDisabledDt};
  return(
    <div className={classes.vitalForm}>
      {vital_info.temperature ?<div>
        <VitalFormTextField {...{...temperature, ...common_parms}}/>
      </div> :null}
      {vital_info.bloods ?<div>
        <VitalFormTextField {...{...maxBloodPressure, ...common_parms}}/>
        <VitalFormTextField {...{...minBloodPressure, ...common_parms}}/>
        <VitalFormTextField {...{...bloodPulse, ...common_parms}}/>
      </div> :null}
      {vital_info.excretion ?<div>
        <VitalFormTextField {...{...excretion, ...common_parms}}/>
      </div> :null}
      {vital_info.spo2 ?<div>
        <VitalFormTextField {...{...spo2, ...common_parms}}/>
      </div> :null}
      {vital_info.sleep===1 ?<div>
        <VitalFormTextField {...{...sleeptime, ...common_parms}}/>
      </div> :null}
      {vital_info.sleep===2 ?<div>
        <VitalFormTextField {...{...bedtime, ...common_parms}}/>
        <VitalFormTextField {...{...wakeuptime, ...common_parms}}/>
      </div> :null}
    </div>
  )
}

const ImgWithDeleteFunc = (props) => {
  const classes = useStyles();
  const {imgUrl, imgIndex, addHandleClick} = props;

  return(
    <div className={classes.imgWithDeleteFunc}>
      <img src={imgUrl} width="200px" />
      <Button className="deleteImg" onClick={()=>addHandleClick(imgIndex)}>
        <HighlightOffIcon style={{color: red[600]}}/>
        <span className='iconButtonStr'>削除</span>
      </Button>
    </div>
  )
}

const SendedImgs = (props) => {
  const {
    contactsDt, setContactsDt, contentDts, setContentDt, uid, imgUrlList, setImgUrlList,
    allState, setSnack, dDate, numOfImgs, setNumOfImgs, setAddImgErr
  } = props;
  const {hid, bid, stdDate, com} = allState;
  const etc = com.etc ?com.etc :{};
  const settingContactBook = etc.settingContactBook ?etc.settingContactBook :{};
  const numOfPhotos = settingContactBook.numOfPhotos ?settingContactBook.numOfPhotos :0;
  const add_handleClick = async(imgIndex) => {
    const deleted_imglist = imgUrlList.filter((_,i) => i !== imgIndex);
    const delete_imgurl = imgUrlList[imgIndex];
    const path = delete_imgurl.replace("https://houday.rbatos.com/contactbookimg/", "");
    const delete_serverimg_res = await axios.post(`https://houday.rbatos.com/api/removeimg.php?path=${path}`);
    if(delete_serverimg_res.data.msg !== "file not found." && !delete_serverimg_res.data.result){
      setSnack({...{msg: '画像の削除に失敗しました。', severity: 'warning'}});
      return;
    }
    const change_content = [...contentDts];
    const send_data = {...contactsDt};
    change_content[2]["photos"] = deleted_imglist;
    send_data["UID"+uid][dDate] = change_content;
    const parms = {a: "sendPartOfContact", hid, bid, date: stdDate, partOfContact: JSON.stringify(send_data)};
    const res = await axios.post(endPoint(), makeUrlSearchParams(parms));
    if(!res.data.result) {
      setSnack({...{msg: '画像の削除に失敗しました。', severity: 'warning'}});
      return;
    }else if(!res.data.msg){
      setSnack({...{msg: '画像を削除しました。', id: new Date().getTime()}});
    }
    setContactsDt({...send_data});
    setContentDt([...change_content])
    setImgUrlList([...deleted_imglist]);
    setNumOfImgs(numOfImgs-1);
    if(numOfImgs-1 <= numOfPhotos) setAddImgErr(false);
  }
  const imgs = imgUrlList.map((imgUrl, index) => {
    const imgdel_parms = {imgUrl, imgIndex: index, addHandleClick: add_handleClick}
    return <ImgWithDeleteFunc key={index} {...imgdel_parms} />
  })
  return(
    <div className='sendedImg'>
      {imgs}
    </div>
  )
}

const AddedImgs = (props) => {
  const {imgList, setImgList, numOfImgs, setNumOfImgs, addImgErr, setAddImgErr, comEtc} = props;
  const etc = comEtc ?comEtc :{};
  const settingContactBook = etc.settingContactBook ?etc.settingContactBook :{};
  const numOfPhotos = settingContactBook.numOfPhotos ?settingContactBook.numOfPhotos :0;
  const add_handleClick = async(imgIndex) => {
    const deleted_imglist = imgList.filter((_,i) => i !== imgIndex);
    setImgList([...deleted_imglist]);
    setNumOfImgs(numOfImgs-1)
    if(numOfImgs-1 <= numOfPhotos) setAddImgErr(false);
  }
  const img_nodes = imgList.map((x, index) => {
    const imgdel_parms = {imgUrl: URL.createObjectURL(x), imgIndex: index, addHandleClick: add_handleClick}
    return <ImgWithDeleteFunc key={index} {...imgdel_parms}/>
  });
  let addimg_errmsg = `画像追加の上限枚数（${numOfPhotos}枚）に達しました。\n上限枚数設定を変更するか画像を削除してください。`;
  if(numOfImgs < numOfPhotos){
    addimg_errmsg = `あと${numOfPhotos-numOfImgs}枚まで追加できます。${numOfPhotos-numOfImgs+1}枚以上追加する場合は、\n上限枚数設定を変更するか画像を削除してください。`
  }

  return(
    <div>
      <div className='beforeSendingImg'>{img_nodes}</div>
      {addImgErr ?<div className='addImgErrMsg'>{addimg_errmsg}</div> :null}
    </div>
  )
}

const CanselButton = (props) => {
  const {allState, contacts, uid, setSnack} = props;
  const handleClick = () => backHistory(contacts, uid, setSnack, allState);

  return(
    <Button
      style={{marginRight: 8, backgroundColor: lightBlue[800], color: 'white'}}
      variant='contained'
      onClick={handleClick}
    >
      キャンセル
    </Button>
  )
}

const ImgUploadButton = (props) => {
  const {imgList, setImgList, disabledDt, setDisabledDt, numOfImgs, setNumOfImgs, comEtc, setSnack, setAddImgErr} = props;
  const etc = comEtc ?{...comEtc} :{};
  const settingContactBook = etc.settingContactBook ?etc.settingContactBook :{};
  const numOfPhotos = settingContactBook.numOfPhotos ?settingContactBook.numOfPhotos :0;
  const handleChange = (e) => {
    const add_numOfImgs = [...e.target.files].length;
    if(numOfImgs+add_numOfImgs <= numOfPhotos){
      setImgList([...imgList, ...e.target.files])
      setDisabledDt({...disabledDt, addImg: false});
      setNumOfImgs(numOfImgs+add_numOfImgs);
      setAddImgErr(false);
    }else{
      setSnack({...{msg: '画像追加に失敗', severity: 'warning', id: new Date().getTime()}});
      setAddImgErr(true);
    }
  }

  return(
    <label
      htmlFor="uploadImgButton"
      style={{marginRight: 8}}
    >
      <input
        hidden
        multiple
        type="file"
        name="image"
        id="uploadImgButton"
        onChange={handleChange}
      />
      <Button
        style={numOfImgs>=numOfPhotos ?{} :{backgroundColor: amber[900], color: 'white'}}
        variant="contained"
        disabled={numOfImgs>=numOfPhotos}
        component="span"
      >
        画像追加
      </Button>
    </label>
  )
}

const ErrMsgs = (props) => {
  const {comEtc, numOfImgs} = props;
  const etc = comEtc ?comEtc :{};
  const settingContactBook = etc.settingContactBook ?etc.settingContactBook :{};
  const numOfPhotos = settingContactBook.numOfPhotos ?settingContactBook.numOfPhotos :0;
  if(numOfImgs > numOfPhotos){
    return(
      <div style={{color: 'red', lineHeight: '1.25rem'}}>
        画像枚数が上限を超えています。<br />
        画像を削除するか、設定より写真枚数設定を変更してください。
      </div>
    )
  }
  return null
}

const SendButton = (props) => {
  const {handleClick, disabledDt} = props;
  let disabled = true;
  if(Object.keys(disabledDt).length){
    disabled = !Object.values(disabledDt).every(x => !x);
  }
  return(
    <Button
      variant='contained'
      color='primary'
      disabled={disabled}
      onClick={handleClick}
    >
      送信
    </Button>
  )
}

const FamilyToOfficeForm = (props) => {
  const classes = useStyles();
  const {contactsDt, setContactsDt, uid, dDate, contentDts, setContentDt, allState, setSnack} = props;
  const {hid, bid, stdDate} = allState;
  const [contentText, setContentText] = useState(contentDts[0]["content"]);
  const [disabledDt, setDisabledDt] = useState({});
  const content_parms = {contentText, setContentText, disabledDt, setDisabledDt};
  const cansel_parms = {contactsDt, uid, allState, setSnack};
  const clickSendButton = async() => {
    const change_contentDt = [...contentDts];
    const send_data = {...contactsDt};
    const uid_str = "UID"+String(uid);
    change_contentDt[0].datetime = getCntbkDateTime(new Date());
    change_contentDt[0].content = lfToBr(contentText);
    if(!send_data[uid_str]) send_data[uid_str] = {};
    send_data[uid_str][dDate] = change_contentDt;
    const parms = {a: "sendPartOfContact", hid, bid, date: stdDate, partOfContact: JSON.stringify(send_data)};
    const res = await axios.post(endPoint(), makeUrlSearchParams(parms));
    if(!res.data.result){
      setSnack({...{msg: '書き込みに失敗しました。', severity: 'warning'}});
    }else{
      setSnack({...{msg: '書き込み完了しました。', id: new Date().getTime()}});
      setContactsDt({...send_data});
      setContentDt([...change_contentDt]);
      setDisabledDt({});
    }
  }
  const send_parms = {handleClick: clickSendButton, disabledDt};
  return(
    <div className={classes.msgForm}>
      <ContentTextField {...content_parms}/>
      <div className='buttonContainer'>
        <CanselButton {...cansel_parms} />
        <SendButton {...send_parms} />
      </div>
    </div>
  )
}

const OfficeToFamilyForm = (props) => {
  const classes = useStyles();
  const {contactsDt, setContactsDt, uid, dDate, contentDts, setContentDt, allState, setSnack} = props;
  const {hid, bid, stdDate, com} = allState;
  const {jino, etc} = com;
  const [contentText, setContentText] = useState(contentDts[2]["content"]);
  const [vitalDt, setVitalDt] = useState(contentDts[2]["vital"] ?contentDts[2]["vital"] :{});
  const [imgUrlList, setImgUrlList] = useState(contentDts[2].photos ?[...contentDts[2].photos] :[]);
  const [imgList, setImgList] = useState([]);
  const [disabledDt, setDisabledDt] = useState({});
  const [numOfImgs, setNumOfImgs] = useState(contentDts[2].photos ?contentDts[2].photos.length :[]);
  const [addImgErr, setAddImgErr] = useState(false);
  const content_parms = {contentText, setContentText, disabledDt, setDisabledDt};
  const vital_parms = {vitalDt, setVitalDt, comEtc: etc, disabledDt, setDisabledDt};
  const saveedImg_parms = {
    contactsDt, setContactsDt, contentDts, setContentDt, uid,
    imgUrlList, setImgUrlList, allState, setSnack, dDate,
    numOfImgs ,setNumOfImgs, setAddImgErr
  };
  const cansel_parms = {contactsDt, uid, allState, setSnack};
  const img_parms = {imgList, setImgList, disabledDt, setDisabledDt, numOfImgs, setNumOfImgs, comEtc: etc, setSnack, addImgErr, setAddImgErr};
  const clickSendButton = async() => {
    const change_contentDt = [...contentDts];
    const send_data = {...contactsDt};
    const ress = [...imgUrlList]; // レスポンスをためておく配列
    const uidZp = zp(uid, 6);
    const today = formatDate(new Date(), 'YYYYMMDD');
    const rnddir = jino + '_' + randomStr(8);
    const rndfname = uidZp + '_' + randomStr(8);
    let i = 0;
    for(const img of imgList){
      const prms = new FormData();
      const fname = img.name;
      console.log(fname, 'fname');
      const ext = fname.split('.').slice(-1)[0]; // 拡張子を取得
      prms.append('file', img, rndfname + '_' + i + '.' + ext);
      prms.append('rnddir', rnddir);
      prms.append('today', today);
      const url = 'https://houday.rbatos.com/api/uploadimg.php';
      const headers = {'content-type': 'multipart/form-data',}
      const res = await axios.post(url, prms, headers);
      if(!res.data.result){
        setSnack({...{msg: '書き込みに失敗しました。', severity: 'warning'}});
        return;
      }
      const path = res.data.filename.replace("..", "");
      ress.push("https://houday.rbatos.com"+path);
      i++;
    }
    setImgUrlList([...ress]);
    setImgList([]);
    change_contentDt[2].photos = ress;
    change_contentDt[2].datetime = getCntbkDateTime(new Date());
    change_contentDt[2].content = lfToBr(contentText);
    change_contentDt[2].vital = vitalDt;
    const uid_str = "UID"+String(uid);
    if(!send_data[uid_str]) send_data[uid_str] = {};
    send_data[uid_str][dDate] = change_contentDt;
    const parms = {a: "sendPartOfContact", hid, bid, date: stdDate, partOfContact: JSON.stringify(send_data)};
    axios.post(endPoint(), makeUrlSearchParams(parms)).then(res => {
      if(!res.data.result){
        setSnack({...{msg: '書き込みに失敗しました。', severity: 'warning'}});
      }else{
        setSnack({...{msg: '書き込み完了しました。', id: new Date().getTime()}});
        setContactsDt({...send_data});
        setContentDt([...change_contentDt]);
        setDisabledDt({});
        setAddImgErr(false);
      }
    })
  }
  const send_parms = {handleClick: clickSendButton, disabledDt}
  return(
    <div className={classes.msgForm}>
      <ContentTextField {...content_parms}/>
      <VitalForm {...vital_parms}/>
      <SendedImgs {...saveedImg_parms}/>
      <AddedImgs {...img_parms}/>
      <ErrMsgs comEtc={etc} numOfImgs={numOfImgs}/>
      <div className='buttonContainer'>
        <CanselButton {...cansel_parms} />
        <ImgUploadButton {...img_parms} />
        <SendButton {...send_parms} />
      </div>
    </div>
  )
}

const ContbkUserEdit = (props) => {
  const classes = useStyles();
  const {uid, calenderDate, contactsDt, setContactsDt} = props;
  const allState = useSelector(state => state);
  const loadingStatus = getLodingStatus(allState);
  const {users, hid, bid, stdDate} = allState;
  const [snack, setSnack] = useState({});
  const [contentDts, setContentDt] = useState(null);
  const select_date = new Date(parseInt(calenderDate));
  const c_year = String(select_date.getFullYear());
  const c_month = String(select_date.getMonth()+1).padStart(2, "0");
  const c_date = String(select_date.getDate()).padStart(2, "0");
  const c_d_date = "D"+c_year+c_month+c_date;
  useEffect(() => {
    if(!loadingStatus.loaded || contentDts) return;
    let isMounted = true;
    (async() => {
      const parms = {a: "fetchContacts", hid, bid, date: stdDate};
      const res = await axios.post(endPoint(), makeUrlSearchParams(parms));
      if(!res.data.result){
        setSnack({...{msg: 'データの取得に失敗しました。', severity: 'warning'}});
      }else if(isMounted){
        const contact_dt = findDeepPath(res.data.dt[0], ["contacts"], {});
        setContactsDt({...contact_dt});
        if(contact_dt["UID"+uid] && contact_dt["UID"+uid][c_d_date]){
          setContentDt([...contact_dt["UID"+uid][c_d_date]]);
        }else{
          setContentDt([{content: ""}, {content: ""}, {content: ""}]);
        }
      }
    })();
    return () => {
      isMounted = false
    }
  }, []);
  const historybutton_parms = {allState, contactsDt, uid, setSnack}
  if(!(loadingStatus.loaded && contentDts)){
    return(
      <>
      <HistoryButton {...historybutton_parms}/>
      <LoadingSpinner />
      </>
    )
  }
  const user = users.find(userDt => userDt.uid === uid);
  const now_time = new Date().getTime();
  const c1d15h_time = new Date(parseInt(c_year), parseInt(c_month)-1, parseInt(c_date)-1, 15);
  const c10h_time = new Date(parseInt(c_year), parseInt(c_month)-1, parseInt(c_date), 10);
  const c20h_time = new Date(parseInt(c_year), parseInt(c_month)-1, parseInt(c_date), 20);
  const ftoo_disabled = c1d15h_time > now_time ?false :true;
  const otof_disabled = (c10h_time < now_time && now_time < c20h_time) ?false :true;
  // const ftoo_disabled = false;
  // const otof_disabled = false;
  const form_parms = {contactsDt, setContactsDt, uid, dDate: c_d_date, contentDts, setContentDt, allState, setSnack};
  return(
    <>
    <div className={classes.cntckEdit} style={{margin: '150px auto', width: 'fit-content'}}>
      <div className='title'>メッセージ編集画面</div>
      <div className='userInfo row'>
        <span>{user.name}</span>
        <span>{user.ageStr}</span>
        <span>{c_month}月{c_date}日</span>
      </div>
      <div className={`contactMsg ${ftoo_disabled ?"row" :""}`}>
        <div className='msgTitle'>事前入力メッセージ</div>
        <div>
          {ftoo_disabled
            ?<div className='str'>{contentDts[0].content ?brtoLf(contentDts[0].content) :"事業所から事前メッセージ"}</div>
            :<FamilyToOfficeForm {...form_parms}/>
          }
        </div>
      </div>
      <div className='contactMsg row'>
        <div className='msgTitle'>ご家族様からのメッセージ</div>
        <div>
          <div className='str'>{contentDts[1].content ?brtoLf(contentDts[1].content) :"メッセージなし"}</div>
        </div>
      </div>
      <div className={`contactMsg ${otof_disabled ?"row" :""}`}>
        <div className='msgTitle'>事業所からのメッセージ</div>
        <div className={otof_disabled ?"input" :""}>
          {otof_disabled
            ?<div className='str'>{contentDts[2].content ?brtoLf(contentDts[2].content) :"事業所から今日の出来事メッセージ"}</div>
            // :null
            :<OfficeToFamilyForm {...form_parms}/>
          }
        </div>
      </div>
    </div>
    <HistoryButton {...historybutton_parms}/>
    <SnackMsg {...snack}/>
    </>

  )
}
export default ContbkUserEdit